import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';
import { DisconnectedGuard } from './disconnected.guard';
import { ThemeResolver } from '../../theme/theme.resolver';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [DisconnectedGuard],
    resolve: { theme: ThemeResolver }
  },
  {
    path: 'login/check',
    component: LoginComponent,
    resolve: { theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth.routes.ts